import CriteriaList from './CriteriaList';
export default CriteriaList;
